import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/warning.svg'


const _hoisted_1 = { class: "bg-white shadow w-full rounded-2xl px-4 py-2 justify-between items-start h-full" }
const _hoisted_2 = { class: "flex flex-row lg:justify-end md:justify-end justify-around space-x-5 p-4 items-center" }
const _hoisted_3 = { class: "pt-2" }
const _hoisted_4 = { class: "pt-2 relative" }
const _hoisted_5 = {
  key: 0,
  class: "pt-2 relative"
}
const _hoisted_6 = { class: "flex justify-center items-center pt-1 relative" }
const _hoisted_7 = /*#__PURE__*/_createStaticVNode("<svg class=\"h-5 w-5\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"><path d=\"M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2\"></path><circle cx=\"8.5\" cy=\"7\" r=\"4\"></circle><line x1=\"18\" y1=\"8\" x2=\"23\" y2=\"13\"></line><line x1=\"23\" y1=\"8\" x2=\"18\" y2=\"13\"></line></svg><span class=\"ml-2 text-sm hidden lg:flex md:flex\">Reject</span>", 2)
const _hoisted_9 = [
  _hoisted_7
]
const _hoisted_10 = { class: "relative flex" }
const _hoisted_11 = {
  key: 0,
  class: "truncate bg-primary text-white text-sm p-2 rounded-full border-2 border-white hover:bg-primary-hover animate__animated animate__fadeIn"
}
const _hoisted_12 = { class: "flex items-center space-x-3" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = {
  key: 1,
  class: "flex flex-col justify-center items-center"
}
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", {
  style: {"border-top-color":"transparent"},
  class: "relative top-6 left-6 w-12 h-12 border-4 border-primary rounded-full animate-spin"
}, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 2,
  class: "pt-1"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "truncate text-white text-sm font-bold px-4 py-2 bg-primary rounded-full" }, "Hired", -1)
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = { class: "lg:space-y-1 mt-8" }
const _hoisted_21 = { class: "flex flex-col lg:flex-row md:flex-row items-center w-full md:space-x-2" }
const _hoisted_22 = { class: "w-full lg:w-2/12 md:w-2/12 flex justify-center mt-4 lg:mt-0" }
const _hoisted_23 = { class: "flex flex-col lg:justify-start md:justify-start lg:items-start md:items-start w-full lg:w-10/12 justify-center items-center text-center lg:text-left md:text-left mt-4 lg:mt-0" }
const _hoisted_24 = { class: "text-xl font-semibold" }
const _hoisted_25 = { class: "text-gray-400 font-light" }
const _hoisted_26 = {
  key: 0,
  class: "text-gray-400 font-light text-sm"
}
const _hoisted_27 = {
  key: 1,
  class: "text-gray-400 font-light"
}
const _hoisted_28 = {
  key: 2,
  class: "text-gray-400 font-light text-sm"
}
const _hoisted_29 = {
  key: 3,
  class: "text-gray-400 font-light"
}
const _hoisted_30 = {
  key: 4,
  class: "w-full flex flex-wrap content-center pt-2"
}
const _hoisted_31 = ["chips"]
const _hoisted_32 = { class: "space-y-3 pt-12" }
const _hoisted_33 = { class: "sm:flex sm:justify-center items-center sm:w-max select-none" }
const _hoisted_34 = ["onClick"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300 mx-4" })
], -1)
const _hoisted_36 = { key: 0 }
const _hoisted_37 = {
  key: 1,
  class: "animate__animated animate__fadeIn"
}
const _hoisted_38 = { class: "space-y-3 p-3 w-full" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "block text-2xl font-bold" }, "Candidate Profile", -1)
const _hoisted_40 = {
  key: 0,
  class: "block text-base font-bold"
}
const _hoisted_41 = { class: "text-xs opacity-30" }
const _hoisted_42 = { class: "text-xs tracking-wide" }
const _hoisted_43 = {
  key: 1,
  class: "flex flex-row items-center py-2"
}
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" }, null, -1)
const _hoisted_45 = [
  _hoisted_44
]
const _hoisted_46 = {
  key: 2,
  class: "block text-base font-bold"
}
const _hoisted_47 = { class: "text-xs opacity-30" }
const _hoisted_48 = { class: "text-xs tracking-wide truncate w-10/12" }
const _hoisted_49 = {
  key: 3,
  class: "flex flex-row items-center py-2"
}
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" }, null, -1)
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  key: 4,
  class: "block text-base font-bold"
}
const _hoisted_53 = {
  key: 5,
  class: "block text-sm font-extralight w-full overflow-ellipsis text-justify"
}
const _hoisted_54 = {
  key: 6,
  class: "block text-base font-bold"
}
const _hoisted_55 = /*#__PURE__*/_createElementVNode("span", { class: "block text-base font-bold" }, "Contact details", -1)
const _hoisted_56 = { class: "flex flex-row w-full space-x-5 items-center" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-extralight text-gray-400" }, "Address", -1)
const _hoisted_58 = { class: "text-sm font-extralight" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_60 = { class: "flex flex-row w-full space-x-8 items-center" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-extralight text-gray-400" }, "Phone", -1)
const _hoisted_62 = { class: "text-sm font-extralight" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_64 = { class: "flex flex-row w-full space-x-8 items-center" }
const _hoisted_65 = /*#__PURE__*/_createElementVNode("span", { class: "text-md font-extralight text-gray-400" }, "Email", -1)
const _hoisted_66 = { class: "text-sm font-extralight" }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row items-center py-2" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex-grow h-0.5 bg-gray-300" })
], -1)
const _hoisted_68 = {
  key: 2,
  class: "p-3"
}
const _hoisted_69 = {
  key: 3,
  class: "p-3"
}
const _hoisted_70 = {
  key: 4,
  class: "p-3"
}
const _hoisted_71 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "mb-3",
  width: "80"
}, null, -1)
const _hoisted_72 = /*#__PURE__*/_createElementVNode("div", { class: "w-full" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "text-lg font-semibold" }, "Are you sure you want to hire this candidate?")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SwitchButton = _resolveComponent("SwitchButton")!
  const _component_MenuShare = _resolveComponent("MenuShare")!
  const _component_MenuEditUser = _resolveComponent("MenuEditUser")!
  const _component_DropDownStage = _resolveComponent("DropDownStage")!
  const _component_Avatar = _resolveComponent("Avatar")!
  const _component_TimeLineSection = _resolveComponent("TimeLineSection")!
  const _component_Chips = _resolveComponent("Chips")!
  const _component_FilesSection = _resolveComponent("FilesSection")!
  const _component_EvaluationsAnswerFrom = _resolveComponent("EvaluationsAnswerFrom")!
  const _component_ChallengeTab = _resolveComponent("ChallengeTab")!
  const _component_ModalRejectCandidate = _resolveComponent("ModalRejectCandidate")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_SwitchButton, {
            fieldId: "visible",
            label: "Visibility",
            checked: _ctx.visible,
            "onUpdate:checked": _ctx.updateVisibility
          }, null, 8, ["checked", "onUpdate:checked"])
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_MenuShare, {
            candidateId: _ctx.userInfo?.candidate?.id,
            jobId: _ctx.userInfo?.job_id
          }, null, 8, ["candidateId", "jobId"])
        ]),
        (_ctx.path === '/job-candidates' || _ctx.$route.name === 'JobCandidates')
          ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
              _createVNode(_component_MenuEditUser, {
                onOpenEdit: _ctx.openEdit,
                onDeleteCandidate: _ctx.deleteCandidate,
                candidateId: _ctx.candidateId,
                jobCandidateId: _ctx.userInfo.candidate.candidate_id,
                stageId: _ctx.stageId,
                onRejectCandidate: _ctx.rejectCandidate
              }, null, 8, ["onOpenEdit", "onDeleteCandidate", "candidateId", "jobCandidateId", "stageId", "onRejectCandidate"])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("span", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.setShowRejected(true))),
            class: "flex lg:truncate bg-gray-100 text-pink-400 text-sm py-2 px-4 cursor-pointer rounded-full border-2 border-white hover:border-pink-200 hover:bg-pink-100 hover:text-pink-500"
          }, _hoisted_9)
        ]),
        _createElementVNode("div", _hoisted_10, [
          (
            _ctx.renderDropDown(_ctx.userInfo?.current_stage) &&
            _ctx.$route.name === 'JobCandidates' &&
            !_ctx.isLoading
          )
            ? (_openBlock(), _createElementBlock("span", _hoisted_11, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("button", {
                    class: "px-2 border-r-2 border-white",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (
                _ctx.validateLastStage(
                  _ctx.userInfo.next_stage?.job_stage?.stage?.name,
                  _ctx.userInfo.next_stage?.id
                )
              ))
                  }, _toDisplayString(_ctx.userInfo.next_stage?.job_stage?.stage?.name), 1),
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_DropDownStage, {
                      stages: _ctx.userInfo?.job_candidate_stages,
                      onReloadCandidates: _ctx.reloadCandidates,
                      onSetLoadingStage: _ctx.setLoadingStage
                    }, null, 8, ["stages", "onReloadCandidates", "onSetLoadingStage"])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, _hoisted_16))
          : _createCommentVNode("", true),
        (
          _ctx.userInfo?.current_stage === 'Hired' &&
          (_ctx.path === '/job-candidates' || _ctx.path === '/job-candidates-detail')
        )
          ? (_openBlock(), _createElementBlock("div", _hoisted_17, _hoisted_19))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_Avatar, {
              name: `${_ctx.userInfo.candidate.first_name} ${_ctx.userInfo.candidate.last_name}`,
              size: "2xl"
            }, null, 8, ["name"])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("span", _hoisted_24, _toDisplayString(`${_ctx.userInfo.candidate.first_name} ${_ctx.userInfo.candidate.last_name}`), 1),
            _createElementVNode("span", _hoisted_25, _toDisplayString(_ctx.userInfo.candidate.position), 1),
            (
              _ctx.userInfo &&
              _ctx.userInfo.candidate &&
              _ctx.userInfo.candidate.salary_expectation !== null
            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(_ctx.buildConvertions(
                _ctx.userInfo?.candidate?.show_monthly_salaries
                  ? _ctx.userInfo?.candidate?.expected_salary_convertion?.MXN / 12
                  : _ctx.userInfo?.candidate?.expected_salary_convertion?.MXN || '0',
                _ctx.userInfo?.candidate?.show_monthly_salaries
                  ? _ctx.userInfo?.candidate?.expected_salary_convertion?.USD / 12
                  : _ctx.userInfo?.candidate?.expected_salary_convertion?.USD || '0'
              )) + " " + _toDisplayString(_ctx.userInfo?.candidate?.show_monthly_salaries ? 'Monthly' : 'Annual'), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_27, " Salary expectation: - ")),
            (
              _ctx.userInfo &&
              _ctx.userInfo.candidate &&
              _ctx.userInfo.candidate.current_salary !== null
            )
              ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(_ctx.buildConvertionsCurrent(
                _ctx.userInfo?.candidate?.show_monthly_salaries
                  ? _ctx.userInfo?.candidate?.current_salary_convertion?.MXN / 12
                  : _ctx.userInfo?.candidate?.current_salary_convertion?.MXN || '0',
                _ctx.userInfo?.candidate?.show_monthly_salaries
                  ? _ctx.userInfo?.candidate?.current_salary_convertion?.USD / 12
                  : _ctx.userInfo?.candidate?.current_salary_convertion?.USD || '0'
              )) + " " + _toDisplayString(_ctx.userInfo?.candidate?.show_monthly_salaries ? 'Monthly' : 'Annual'), 1))
              : (_openBlock(), _createElementBlock("span", _hoisted_29, " Current salary: - ")),
            (_ctx.userInfo && _ctx.userInfo.candidate.skills.length > 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userInfo &&
              _ctx.userInfo.candidate &&
              _ctx.userInfo.candidate.skills &&
              _ctx.userInfo.candidate.skills.length > 0
                ? _ctx.userInfo.candidate.skills.slice(0, 3)
                : [], (chip) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass([chip.length >= 16 && 'sm:w-20 2xl:w-28', "items-center mr-1 mt-1 mb-1 rounded-lg px-2 py-1 2xl:text-sm sm:text-xs font-medium bg-primary-light text-primary-dark truncate"]),
                      chips: _ctx.userInfo.candidate.skills,
                      key: chip
                    }, _toDisplayString(chip), 11, _hoisted_31))
                  }), 128))
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_32, [
        _createElementVNode("ul", _hoisted_33, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabs, (tab, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("li", {
                class: _normalizeClass(["cursor-pointer py-1 px-4 rounded transition text-black font-bold", _ctx.activeTab !== _ctx.tabs[index] && ' text-black opacity-30']),
                onClick: ($event: any) => (_ctx.changeCandidateTab(index))
              }, _toDisplayString(tab), 11, _hoisted_34)
            ]))
          }), 128))
        ]),
        _hoisted_35
      ]),
      (_ctx.activeTab === `Timeline`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_36, [
            _createVNode(_component_TimeLineSection, {
              onOpenEdit: _ctx.openEdit,
              userEmail: _ctx.userInfo.candidate.email
            }, null, 8, ["onOpenEdit", "userEmail"])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === `Profile`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              (
            _ctx.userInfo &&
            _ctx.userInfo.candidate &&
            _ctx.userInfo.candidate.candidate_work_histories &&
            _ctx.userInfo.candidate.candidate_work_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("span", _hoisted_40, " Work experience "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userInfo.candidate.candidate_work_histories, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `item-work-${index + 1}`,
                  class: "flex flex-row items-center space-x-4"
                }, [
                  _createElementVNode("span", _hoisted_41, _toDisplayString(`${
              item.start_date !== null
                ? new Date(item.start_date).getFullYear()
                : '?'
            } - ${
              item.end_date !== null
                ? _ctx.buildNow(
                    new Date(item.end_date).getFullYear(),
                    item.is_current
                  )
                : '?'
            }`), 1),
                  _createElementVNode("span", _hoisted_42, _toDisplayString(`${item.job_title} at ${
                item?.company_name ? item.company_name : ' Not specified'
              }`), 1)
                ]))
              }), 128)),
              (
            _ctx.userInfo &&
            _ctx.userInfo.candidate &&
            _ctx.userInfo.candidate.candidate_work_histories &&
            _ctx.userInfo.candidate.candidate_work_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_43, _hoisted_45))
                : _createCommentVNode("", true),
              (
            _ctx.userInfo &&
            _ctx.userInfo.candidate &&
            _ctx.userInfo.candidate.candidate_education_histories &&
            _ctx.userInfo.candidate.candidate_education_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("span", _hoisted_46, " Education "))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userInfo.candidate
            .candidate_education_histories, (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: `item-work-${index + 1}`,
                  class: "flex flex-row items-center space-x-4"
                }, [
                  _createElementVNode("span", _hoisted_47, _toDisplayString(`${
              item.start_date !== null
                ? new Date(item.start_date).getFullYear()
                : '?'
            } - ${
              item.end_date !== null
                ? _ctx.buildNow(
                    new Date(item.end_date).getFullYear(),
                    item.is_current
                  )
                : '?'
            }`), 1),
                  _createElementVNode("span", _hoisted_48, _toDisplayString(`${item.degree !== null ? item.degree : 'Unspecified'} at ${
                item.learning_center
              }`), 1)
                ]))
              }), 128)),
              (
            _ctx.userInfo &&
            _ctx.userInfo.candidate &&
            _ctx.userInfo.candidate.candidate_education_histories &&
            _ctx.userInfo.candidate.candidate_education_histories.length > 0
          )
                ? (_openBlock(), _createElementBlock("div", _hoisted_49, _hoisted_51))
                : _createCommentVNode("", true),
              (_ctx.userInfo && _ctx.userInfo.candidate.summary)
                ? (_openBlock(), _createElementBlock("span", _hoisted_52, " Summary "))
                : _createCommentVNode("", true),
              (_ctx.userInfo && _ctx.userInfo.candidate.summary)
                ? (_openBlock(), _createElementBlock("span", _hoisted_53, _toDisplayString(_ctx.userInfo.candidate.summary), 1))
                : _createCommentVNode("", true),
              (_ctx.userInfo && _ctx.userInfo.candidate.skills.length > 0)
                ? (_openBlock(), _createElementBlock("span", _hoisted_54, " Skills "))
                : _createCommentVNode("", true),
              (_ctx.userInfo && _ctx.userInfo.candidate.skills.length > 0)
                ? (_openBlock(), _createBlock(_component_Chips, {
                    key: 7,
                    chips: _ctx.userInfo.candidate.skills,
                    isInput: false
                  }, null, 8, ["chips"]))
                : _createCommentVNode("", true),
              _hoisted_55,
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("span", _hoisted_58, _toDisplayString(_ctx.userInfo.candidate?.candidate_location
              ? _ctx.userInfo.candidate?.candidate_location.location.street_address
              : 'No address'), 1)
              ]),
              _hoisted_59,
              _createElementVNode("div", _hoisted_60, [
                _hoisted_61,
                _createElementVNode("span", _hoisted_62, _toDisplayString(_ctx.userInfo.candidate.phone), 1)
              ]),
              _hoisted_63,
              _createElementVNode("div", _hoisted_64, [
                _hoisted_65,
                _createElementVNode("span", _hoisted_66, _toDisplayString(_ctx.userInfo.candidate.email), 1)
              ]),
              _hoisted_67
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === `Files`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
            _createVNode(_component_FilesSection)
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === `Talent evaluation`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
            _createVNode(_component_EvaluationsAnswerFrom)
          ]))
        : _createCommentVNode("", true),
      (_ctx.activeTab === `Challenge`)
        ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
            _createVNode(_component_ChallengeTab, {
              candidateId: _ctx.userInfo?.id,
              onReloadOne: _ctx.reloadOne,
              status: _ctx.userInfo?.job_candidate_challenge?.challenge_status,
              isSent: _ctx.userInfo?.challenge_sent,
              data: _ctx.userInfo?.job_candidate_challenge,
              resend: _ctx.userInfo?.can_resend_challenge
            }, null, 8, ["candidateId", "onReloadOne", "status", "isSent", "data", "resend"])
          ]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ModalRejectCandidate, {
      showModal: _ctx.showRejected,
      onCloseModal: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setShowRejected(false))),
      candidateId: _ctx.userInfo.candidate.candidate_id,
      stageId: _ctx.stageId,
      onReloadCandidates: _ctx.reloadCandidates
    }, null, 8, ["showModal", "candidateId", "stageId", "onReloadCandidates"]),
    _createVNode(_component_base_modal, { visible: _ctx.showConfirmationModal }, {
      thumbnail: _withCtx(() => [
        _hoisted_71
      ]),
      "alert-text": _withCtx(() => [
        _hoisted_72
      ]),
      actions: _withCtx(() => [
        _createElementVNode("button", {
          class: "btn-outline-sm flex flex-row items-center disabled:opacity-50 justify-between px-4 py-2 text-primary truncate sm:text-base border-2 rounded-full transition duration-150 ease-in",
          onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(false)), ["prevent"]))
        }, " Cancel "),
        _createElementVNode("button", {
          class: "btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate sm:text-base bg-primary rounded-full transition duration-150 ease-in",
          onClick: _cache[4] || (_cache[4] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(true)), ["prevent"]))
        }, " Hire ")
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}